import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link as _Link } from 'react-router-dom';
import { Button } from '@material-ui/core';

import useTranslateText from './use_translate_text';
import { isExternalUrl } from './utils/string_utils';
import '../scss/button.scss';

export const Link = (props) => {
  const { to, className } = props;

  if (!to) return null;

  const isExternal = isExternalUrl(to);

  if (isExternal) {
    return (
      <a
        className={className}
        href={to}
        rel="noreferrer noopener"
        target="_blank"
        {...props}
      >
        { props.children }
        { isExternal && <span className="sr-only">Opens in a new window</span>}
      </a>
    );
  }

  return (<_Link {...{ to, className, ...props }} />);
};

export const PrimaryLink = (props) => {
  const { className, icon, size, label, to } = props,
        { translateText } = useTranslateText(),
        classNames = `primary-button ${className}`;

  return (
    <Link to={to} className={classNames} title={translateText(label)}>
      {icon &&
        <FontAwesomeIcon
          icon={icon}
          size={size || '1x'}
        />
      }
      {translateText(label)}
    </Link>
  );
};

export const PrimaryLinkRight = (props) => {
  const { className, icon, size, label, to, disable } = props,
        { translateText } = useTranslateText(),
        classNames = `primary-button__right ${className}`;

  return (
    !disable && <Link to={to} className={classNames} title={translateText(label)}>
      {translateText(label)}
      {icon &&
        <FontAwesomeIcon
          icon={icon}
          size={size || '1x'}
        />
      }
    </Link>
    ||
    <Button className={classNames} title={translateText(label)} disabled={disable}>
      {translateText(label)}
      <FontAwesomeIcon
        icon={icon}
        size={size || '1x'}
      />
    </Button>
  );
};

export const PrimaryPopUpLinkRight = (props) => {
  const { className, icon, size, label, onClick, isDisabled } = props,
        { translateText } = useTranslateText(),
        classNames = `primary-button__right ${className}`;

  return (
    <button
      className={classNames}
      onClick={onClick}
      disabled={isDisabled}
      title={translateText(label)}
    >
      {translateText(label)}
      {icon &&
        <FontAwesomeIcon
          icon={icon}
          size={size || '1x'}
        />
      }
    </button>
  );
};

export const PrimaryLinkRoundBorder = (props) => {
  const { className, icon, size, label, to, img } = props,
        { translateText } = useTranslateText(),
        classNames = `primary-button__round-border ${className}`;

  return (
    <Link to={to} className={classNames} title={translateText(label)}>
      {img && <img src={img} alt={label} />}
      {translateText(label)}
      {icon &&
        <FontAwesomeIcon
          icon={icon}
          size={size || '1px'}
        />
      }
    </Link>
  );
};
